import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import {
	getAttentionCounts,
	getBankTransactions,
	getCashExpenses,
	getEquityContributions,
	getEvents,
	getFinanceSummary,
	getInvoiceMailMessage,
	getInvoiceMails,
	getInvoices,
	getSalesOverview,
} from '../lib/api'
import type { SalesDetailPeriod } from '../types'

export const financeKeys = {
	all: ['finance'] as const,
	invoices: () => [...financeKeys.all, 'invoices'] as const,
	equityContributions: () => [...financeKeys.all, 'equity-contributions'] as const,
	bankTransactions: () => [...financeKeys.all, 'bank-transactions'] as const,
	events: () => [...financeKeys.all, 'events'] as const,
	summary: () => [...financeKeys.all, 'summary'] as const,
	cashExpenses: () => [...financeKeys.all, 'cash-expenses'] as const,
	attentionCounts: () => [...financeKeys.all, 'attention-counts'] as const,
	salesOverview: (period: SalesDetailPeriod) => [...financeKeys.all, 'sales-overview', period] as const,
	invoiceMails: () => [...financeKeys.all, 'invoice-mails'] as const,
	invoiceMailMessage: (mailId: number) => [...financeKeys.all, 'invoice-mail-message', mailId] as const,
}

export const invoicesQuery = () => queryOptions({ queryKey: financeKeys.invoices(), queryFn: getInvoices })

export const equityContributionsQuery = () => queryOptions({ queryKey: financeKeys.equityContributions(), queryFn: getEquityContributions })

export const bankTransactionsQuery = () => queryOptions({ queryKey: financeKeys.bankTransactions(), queryFn: getBankTransactions })

export const eventsQuery = () => queryOptions({ queryKey: financeKeys.events(), queryFn: getEvents })

export const financeSummaryQuery = () => queryOptions({ queryKey: financeKeys.summary(), queryFn: getFinanceSummary })

export const cashExpensesQuery = () => queryOptions({ queryKey: financeKeys.cashExpenses(), queryFn: getCashExpenses })

export const financeAttentionQuery = () => queryOptions({ queryKey: financeKeys.attentionCounts(), queryFn: getAttentionCounts })

export const salesOverviewQuery = (period: SalesDetailPeriod = 'this_month') =>
	queryOptions({ queryKey: financeKeys.salesOverview(period), queryFn: () => getSalesOverview(period), placeholderData: keepPreviousData })

export const invoiceMailsQuery = () => queryOptions({ queryKey: financeKeys.invoiceMails(), queryFn: getInvoiceMails })

export const invoiceMailMessageQuery = (mailId: number) =>
	queryOptions({ queryKey: financeKeys.invoiceMailMessage(mailId), queryFn: () => getInvoiceMailMessage(mailId), staleTime: Infinity })
